import { success as successNotif, error as errorNotif } from "react-notification-system-redux";

import { customerService } from "_services";
import { checkIfPaymentMethodNotChanged, createBillingHash, resetBillingCounter } from "_helpers/billing";
import { customerTypes } from "../types";

export const customerActions = {
  getPaymentMethods,
  postPaymentMethod,
  getSubscriptions,
  cancelSubscription,
};

function getPaymentMethods() {
  return (dispatch) => {
    dispatch(request());

    customerService.getPaymentMethods().then(
      async (paymentMethods) => {
        const paymentMethodData = paymentMethods?.find((item) => item?.primary);
        const isPaymentMethodNotChanged = await checkIfPaymentMethodNotChanged(paymentMethodData);

        if (!isPaymentMethodNotChanged) {
          await createBillingHash(paymentMethodData);
          resetBillingCounter();
        }

        dispatch(success(paymentMethods));
      },
      (error) => {
        if (!error.isResponse) {
          customerService.crmGetPaymentMethods().then(
            async (paymentMethods) => {
              const paymentMethodData = paymentMethods?.find((item) => item?.primary);
              const isPaymentMethodNotChanged = await checkIfPaymentMethodNotChanged(paymentMethodData);

              if (!isPaymentMethodNotChanged) {
                await createBillingHash(paymentMethodData);
                resetBillingCounter();
              }
              dispatch(success(paymentMethods));
            },
            (error) => dispatch(failure(error.toString()))
          );
        } else {
          dispatch(failure(error.toString()));
        }
      }
    );
  };

  function request() {
    return { type: customerTypes.GET_PAYMENT_METHODS_REQUEST };
  }

  function success(payload) {
    return { type: customerTypes.GET_PAYMENT_METHODS_SUCCESS, payload };
  }

  function failure() {
    return { type: customerTypes.GET_PAYMENT_METHODS_FAILURE };
  }
}

function postPaymentMethod(cardDetails, cb) {
  return (dispatch) => {
    dispatch(request());

    customerService.postPaymentMethod(cardDetails).then(
      () => {
        dispatch(
          successNotif({
            title: "Success",
            message: `Payment method has been changed.`,
          })
        );
        dispatch(success());
        if (cb) cb();
        dispatch(getPaymentMethods());
      },
      (error) => {
        if (!error.isResponse) {
          customerService.crmPostPaymentMethod(cardDetails).then(
            () => {
              dispatch(
                successNotif({
                  title: "Success",
                  message: `Payment method has been changed.`,
                })
              );
              dispatch(success());
              if (cb) cb();
              dispatch(getPaymentMethods());
            },
            (error) => {
              dispatch(
                errorNotif({
                  title: "Error",
                  message: error.toString(),
                })
              );
              dispatch(failure(error.toString()));
            }
          );
        } else {
          dispatch(
            errorNotif({
              title: "Error",
              message: error.toString(),
            })
          );
          dispatch(failure(error.toString()));
        }
      }
    );
  };

  function request() {
    return { type: customerTypes.POST_PAYMENT_METHOD_REQUEST };
  }

  function success() {
    return { type: customerTypes.POST_PAYMENT_METHOD_SUCCESS };
  }

  function failure() {
    return { type: customerTypes.POST_PAYMENT_METHOD_FAILURE };
  }
}

function getSubscriptions() {
  return (dispatch) => {
    dispatch(request());

    customerService.getSubscriptions().then(
      (subscriptions) => dispatch(success(subscriptions)),
      (error) => {
        if (!error.isResponse) {
          customerService.crmGetSubscriptions().then(
            (subscriptions) => dispatch(success(subscriptions)),
            (error) => dispatch(failure(error.toString()))
          );
        } else {
          dispatch(failure(error.toString()));
        }
      }
    );
  };

  function request() {
    return { type: customerTypes.GET_SUBSCRIPTIONS_REQUEST };
  }

  function success(payload) {
    return { type: customerTypes.GET_SUBSCRIPTIONS_SUCCESS, payload };
  }

  function failure() {
    return { type: customerTypes.GET_SUBSCRIPTIONS_FAILURE };
  }
}

function cancelSubscription(orderId, productId, productName) {
  return (dispatch) => {
    dispatch(request());

    customerService.postCancelSubscriptions(orderId, productId).then(
      () =>
        customerService.getSubscriptions().then(
          (subscriptions) => {
            dispatch(
              successNotif({
                title: "Unsubscribed",
                message: `Your ${productName} subscription has been successfully cancelled, you will not receive any further charges for it.`,
              })
            );
            dispatch(success(subscriptions));
          },
          (error) => dispatch(failure(error.toString()))
        ),
      (error) => {
        if (!error.isResponse) {
          customerService.crmPostCancelSubscriptions(orderId, productId).then(
            () =>
              customerService.crmGetSubscriptions().then(
                (subscriptions) => {
                  dispatch(
                    successNotif({
                      title: "Unsubscribed",
                      message: `Your ${productName} subscription has been successfully cancelled, you will not receive any further charges for it.`,
                    })
                  );
                  dispatch(success(subscriptions));
                },
                (error) => dispatch(failure(error.toString()))
              ),
            (error) => {
              dispatch(
                errorNotif({
                  title: "Error",
                  message: "Something went wrong. Your request has not been executed. Try again.",
                })
              );
              dispatch(failure(error.toString()));
            }
          );
        } else {
          dispatch(
            errorNotif({
              title: "Error",
              message: "Something went wrong. Your request has not been executed. Try again.",
            })
          );
          dispatch(failure(error.toString()));
        }
      }
    );
  };

  function request() {
    return { type: customerTypes.CANCEL_SUBSCRIPTION_REQUEST };
  }

  function success(payload) {
    return { type: customerTypes.CANCEL_SUBSCRIPTION_SUCCESS, payload };
  }

  function failure() {
    return { type: customerTypes.CANCEL_SUBSCRIPTION_FAILURE };
  }
}
